export default __webpack_public_path__ + "static/media/portgo-screenshot-04.073bfb34.png";